// Local fallback logos for tenants who haven't configured a logo URL in their
// branding data. Every image dropped into CompanyData/B2Clogos is picked up
// automatically — no code changes needed — as long as it's named after the
// tenant's domain (its first label, e.g. "epicdestino.in" -> epicdestino.png).
const logoContext = require.context('../../CompanyData/B2Clogos', false, /\.(png|jpe?g|svg|webp)$/i);

const LOGO_MAP = {};
logoContext.keys().forEach((key) => {
  const filename = key.replace(/^\.\//, '');
  const label = filename.replace(/\.[^.]+$/, '').toLowerCase();
  LOGO_MAP[label] = logoContext(key);
});

/**
 * Resolves a locally-bundled fallback logo for a tenant's domain, keyed by the
 * domain's first label (e.g. "epicdestino.in" / "www.epicdestino.in" -> "epicdestino").
 * Returns null when no matching file exists in CompanyData/B2Clogos, so callers
 * can fall further back to a text brand-name.
 */
export const getLocalLogoUrl = (domain) => {
  if (!domain) return null;
  const label = domain.toLowerCase().replace(/^www\./, '').split('.')[0];
  return LOGO_MAP[label] || null;
};
